import React, { useState, useEffect } from "react";
import { FaSearch } from "react-icons/fa";
import { Link } from "react-router-dom";
import { Movies } from "../screen components/Data/MovieData";

const SearchBox = ({ movie }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredData, setFilteredData] = useState([]);

  //creating a search functionality using useeffect hook
  useEffect(() => {
    if (searchTerm !== "") {
      const results = Movies.filter((item) =>
        item.name.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredData(results);
    } else {
      setFilteredData([]);
    }
  }, [searchTerm, movie]);

  return (
    <div>
      <form className="w-full text-sm bg-text rounded flex-btn gap-4">
        <button
          type="submit"
          className="bg-subMain w-12 flex-colo h-12 rounded text-white"
        >
          <FaSearch />
        </button>
        <input
          value={searchTerm}
          onChange={(event) => setSearchTerm(event.target.value)}
          type="text"
          placeholder="Search Movie Name from here"
          className="font-medium placeholder:text-border text-sm w-full h- bg-transparent border-none px-2 text-black"
        />
      </form>

      <div>
        {filteredData.map((movie) => (
          <Link key={movie.id} to={`/movies/:id/${movie.id}`}>
            <div>{movie.name}</div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default SearchBox;
